import React from 'react';
import striptags from 'striptags';

type Props = {
    html: string,
}

const VideoEmbed: React.FC<Props> = ({ html }) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: striptags(html, ['iframe']) }} />
    )
}

export default VideoEmbed;